enum EZielwert{
  LAUFZEIT="LAUFZEIT",
  TILGUNGSSATZ="TILGUNGSSATZ",
  ANNUITAET="ANNUITAET"
}

export default EZielwert;
